import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement);
export default function BarChart({ data }) {
  const chartData = {
    labels: data.map(item =>
      item.title.split(" ").slice(0, 3).join(" ") + (item.title.split(" ").length > 3 ? "..." : "")
    ),
    datasets: [
      {
        label: "Total Bids Received",
        data: data.map(item => item.totalBidAmount),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  };



  return (
    <div className="chartCard">
      <h3>Bids Received per Property</h3>
      <Bar data={chartData}/>
    </div>
  );
}
